module.exports = __webpack_public_path__ + "img/logo_chrono_fresh.628ca936.webp";